import { translate } from "../localization";
const IMAGE_EXTENSIONS = [".png", ".jpg", ".jpeg"];
const THREE_D_MODEL_EXTENSIONS = [".obj", ".fbx", ".glb", ".gltf", ".stl"];

export const SUPPORTED_ELEMENT_FILE_EXTENSIONS = [
  ...THREE_D_MODEL_EXTENSIONS,
  ".pdb",
  ".zip",
  ".swc",
];

const SUPPORTED_ELEMENT_MIME_TYPES = ["image/png", "image/jpeg", "model/stl"];

export const SUPPORTED_ELEMENT_FILE_INPUT_ACCEPT = [
  "image/png",
  "image/jpeg",
  ...SUPPORTED_ELEMENT_FILE_EXTENSIONS,
].join(", ");

export const getSupportedElementFileHelperText =
  () => translate("Supported file types: FBX, OBJ, STL, JPG, PNG, PDB, ZIP, GLB, GLTF, SWC");

export const getElementFileExtension = (fileName = "") => {
  const dotIndex = fileName.lastIndexOf(".");
  if (dotIndex < 0) {
    return "";
  }

  return fileName.slice(dotIndex).toLowerCase();
};

export const isSupportedElementFile = (file) => {
  if (!file) {
    return false;
  }

  const fileType = file.type?.toLowerCase();
  if (fileType && SUPPORTED_ELEMENT_MIME_TYPES.includes(fileType)) {
    return true;
  }

  return SUPPORTED_ELEMENT_FILE_EXTENSIONS.includes(getElementFileExtension(file.name));
};

export const isElementImageFile = (fileName = "") =>
  IMAGE_EXTENSIONS.includes(getElementFileExtension(fileName));

export const getElementFileConfig = (fileName = "") => {
  switch (getElementFileExtension(fileName)) {
    case ".png":
    case ".jpg":
    case ".jpeg":
      return {
        visualizerData: {
          dataType: 1,
          visualizationType: 3,
          defaultMaterialName: "DefaultSpriteMaterial",
        },
        worldUnit: {
          value: 40,
        },
      };
    case ".obj":
    case ".fbx":
    case ".glb":
    case ".gltf":
    case ".stl":
      return {
        visualizerData: {
          dataType: 4,
          visualizationType: 2,
        },
      };
    case ".swc":
      return {
        visualizerData: {
          dataType: 4,
          visualizationType: 2,
        },
        worldUnit: {
          value: 1,
          units: 4,
        },
      };
    case ".pdb":
      return {
        visualizerData: {
          dataType: 1,
          visualizationType: 6,
        },
        worldUnit: {
          value: 1,
          units: 2,
        },
      };
    default:
      return null;
  }
};

export const getElementUploadContentType = (file) => {
  if (!file) {
    return undefined;
  }

  if (file.type) {
    return file.type;
  }

  if (getElementFileExtension(file.name) === ".stl") {
    return "model/stl";
  }

  return undefined;
};
